import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Card } from '../components/ui';
import { linkButtonClass } from '../utils/linkButtonClass';
import Layout from '../components/Layout';

export default function BillingCancelPage() {
  return (
    <Layout>
      <div className="flex-1 flex items-center justify-center">
        <Card className="max-w-md w-full text-center">
          <div className="flex justify-center mb-6">
            <XCircle className="w-20 h-20 text-gray-400" />
          </div>

          <h1 className="text-2xl font-bold mb-4">お支払いがキャンセルされました</h1>

          <p className="text-gray-600 mb-6">
            決済処理がキャンセルされました。<br />
            ご不明な点がございましたらお問い合わせください。
          </p>

          <div className="space-y-3">
            <Link to="/billing" className={linkButtonClass('primary', 'block w-full')}>
              プラン選択に戻る
            </Link>
            <Link to="/dashboard" className={linkButtonClass('secondary', 'block w-full')}>
              ダッシュボードへ
            </Link>
          </div>
        </Card>
      </div>
    </Layout>
  );
}
